import { Input } from '@components/Input'

import { Container } from './TitleInput.styled'

interface TitleInputProps {
  value: string
  onChange: (value: string) => void
}

export const TitleInput: React.FC<TitleInputProps> = ({ value, onChange }: TitleInputProps) => {
  return (
    <Container>
      <Input
        type="text"
        required
        label="Nom du modèle"
        value={value}
        onChange={(value) => onChange(value)}
        placeholder="Nom du modèle"
      />
    </Container>
  )
}
